import { UPDATE_COUNTRY_LIST, UPDATE_STATES_LIST } from "./types";

export const updateCountryList = (payload) => {
  return {
    type: UPDATE_COUNTRY_LIST,
    payload: payload,
  };
};

export const updateStateByQuesIdList = (payload) => {
  return {
    type: UPDATE_STATES_LIST,
    payload: payload,
  };
};
